module.exports = __webpack_public_path__ + "img/comprehensive-setting.c1369d4f.svg";